module.exports = __webpack_public_path__ + "img/logo.8c3d597.svg";